module.exports = __webpack_public_path__ + "media/images/logo-playsquad-f68bd326dbda60e42e86fc5de7471e1b.png";